<div class="header-title">
  @if (showBackBtn) {
    <liberro-back-button
      [top]="'0'"
      [partOfHeaderSection]="true"
      [dataCy]="backButtonDataCy"
      (click)="goBack()"
    ></liberro-back-button>
  }
  <ng-content select="[title]"></ng-content></div>
@if (!withoutDescription) {
  <div class="header-content" [class.header-content--small-mt]="headerContentSmallMt">
    <ng-content select="[description]"></ng-content>
  </div>
}
@if (showDescDivider) {
  <nz-divider [class.mobile-divider]="showDescDividerMobile"></nz-divider>
}
